import { PDMenuItem } from './menu.type';
import { hasPermissionSmart } from '@/utils/permissions';
import { sharedMenuRaw } from './shared.menu';
import { defaultMenuRaw } from './default.menu';
import { modulesMenus } from './modules';

export type MenuItemInput = Omit<PDMenuItem, 'permission' | 'submenu'> & {
  permission?: boolean | string;
  submenu?: MenuItemInput[];
};

/**
 * Constrói o menu, aplicando permissions.
 */
export function buildMenuWithPermissions(
  menu: MenuItemInput[],
  userPermissions: string[],
): PDMenuItem[] {
  return menu.map((item) => {
    const permission =
      typeof item.permission === 'string'
        ? hasPermissionSmart(userPermissions, item.permission)
        : (item.permission ?? true);

    let processedSubmenu: PDMenuItem[] = [];
    if (item.submenu) {
      processedSubmenu = buildMenuWithPermissions(
        item.submenu,
        userPermissions,
      );
    }

    const hasSubmenuPermission = processedSubmenu.some(
      (child) => child.permission,
    );

    return {
      ...item,
      permission: permission || hasSubmenuPermission,
      submenu: processedSubmenu.length > 0 ? processedSubmenu : undefined,
    };
  });
}

/**
 * Retorna o menu completo (shared + módulo) baseado na URL.
 */
export function getFullMenu(
  currentPath: string,
  permissions: string[] | null | undefined,
): PDMenuItem[] {
  const pathModule = currentPath.split('/').filter(Boolean)[0];
  let moduleKey = pathModule;

  if (!Object.keys(modulesMenus).includes(moduleKey)) {
    moduleKey = sessionStorage.getItem('activeModule') || '';
  }

  const safePermissions = permissions ?? [];

  const moduleMenu = modulesMenus[moduleKey] || [];

  return [
    ...buildMenuWithPermissions(defaultMenuRaw, safePermissions),
    ...buildMenuWithPermissions(moduleMenu, safePermissions),
    ...buildMenuWithPermissions(sharedMenuRaw, safePermissions),
  ];
}
